const Events = [
  {
    path: '/events',
    name: 'Events',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Agenda',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/events_agenda/Agenda.vue`)
  },
  {
    path: '/new_event',
    name: 'NewEvent',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Novo evento',
      icon: '📘',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/events_agenda/NewEvent.vue`)
  },
  {
    path: '/event/:id',
    name: 'ShowEvent',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Editando evento',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/events_agenda/ShowEvent.vue`)
  },
  {
    path: '/new_schedule_lock',
    name: 'NewScheduleLock',
    meta: { 
      // needs_company: true,
      tab_name: 'Bloqueio de agenda',
      icon: '🗓️',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/events_agenda/NewEvent.vue`)
  },
  
]

export default Events
